/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import XSvg from "components/Icons/XSvg";
import { toast } from "react-hot-toast";
import { v4 as uuid } from "uuid";
// This function is used to handle passing the Figma styles to the toast
type ToastType = "success" | "error" | "warning" | "new" | "default";
enum ToastVariantLabel {
  success = "Success",
  error = "Error",
  warning = "Attention",
  new = "New Feature",
}

const toastBadgeLabelStyle = {
  error: {
    color: "var(--theme-colors-danger-card-fg)",
    backgroundColor: "var(--theme-colors-danger-card-bg)",
  },
  warning: {
    color: "var(--theme-colors-warning-card-fg)",
    backgroundColor: "var(--theme-colors-warning-card-bg)",
  },
  success: {
    color: "var(--theme-colors-success-card-fg)",
    backgroundColor: "var(--theme-colors-success-card-bg)",
  },
  new: {
    color: "var(--theme-colors-info-card-fg)",
    backgroundColor: "var(--theme-colors-info-card-bg)",
  },
  default: {},
};

const ToastBadge = ({ type }: { type: ToastType }) => {
  if (type === "default") return null;
  return (
    <div
      className={
        "py-0.5 px-2 h-full flex items-center justify-start font-medium rounded-2xl text-sm "
      }
      style={toastBadgeLabelStyle[type]}
      test-id="aS_WXa_r"
    >
      <span className="" test-id="vR6awXkG">
        {ToastVariantLabel[type]}
      </span>
    </div>
  );
};

const openToast = (
  message: string,
  type: ToastType = "default",
  duration = 5000,
) => {
  const toastId = uuid();
  const closeToast = () => toast.dismiss(toastId);
  const icon = <ToastBadge type={type} test-id="pJ6NPHMT" />;
  const Message = ({ message }: { message: string }) => (
    <div className="flex items-center gap-x-2 text-sm">
      {message}
      <button onClick={closeToast}>
        <XSvg fill="currentColor" width="18" height="18" />
      </button>
    </div>
  );
  return toast(<Message message={message} />, {
    icon,
    duration,
    id: toastId,
    style: {
      borderRadius: "20px",
      fontSize: "14px",
      padding: "6px",
      alignItems: "center",
    },
  });
};

export default openToast;
